export class FiscalYear {

    public FiscalYearId:number;

    public Name:string

    public Description:string;

    public StartDate:Date;

    public EndDate:Date;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/fiscal-year.ts